import React from 'react';
import { Box, Flex, xcss, Text, Grid } from '@atlaskit/primitives';
import { NoData } from '..';
import './info-section.scss';

const boxStyles = xcss({
  backgroundColor: 'elevation.surface',
  borderColor: 'color.border',
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderRadius: 'border.radius.200',
});

interface Props {
  items?: {
    label: string;
    value?: React.ReactNode;
    // testId: Test ID for the value.
    testId?: string;
    // isRightAligned: Right align the content, its text and its subsequent contents. For subsequent contents, the
    // text alignment will be left - aligned.To make them right - aligned, add isRightAligned to them.
    isRightAligned?: boolean;
    subValue?: string | undefined;
  }[];
  columnsCount?: number;
}

const generateTemplateColumns = (columnsCount: number) => {
  return Array(columnsCount).fill('0.2fr').join(' ');
};

export const InfoSection = ({ items, columnsCount = 3 }: Props) => {
  if (!items?.length) {
    return null;
  }

  const renderItems = () => {
    return items.map((item) => {
      return (
        <div className={item?.isRightAligned ? 'info-section-box-wrapper' : ''} key={item.label}>
          <Flex direction="column">
            <Text weight="semibold" color="color.text.subtlest">
              {item.label}
            </Text>
            <Text testId={item?.testId}>{item?.value || <NoData />} </Text>
            {item?.subValue && (
              <Text testId={item?.testId} color="color.text.subtlest">
                {item?.subValue}
              </Text>
            )}
          </Flex>
        </div>
      );
    });
  };

  const templateColumns = generateTemplateColumns(columnsCount);

  return (
    <Box padding="space.300" xcss={boxStyles} testId="info-section-wrapper">
      <Grid templateColumns={templateColumns}>{renderItems()}</Grid>
    </Box>
  );
};
